import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetFoodAdmin = LazyLoad(() => import('./PetFoodAdmin'));

export { PetFoodAdmin };
